(function(){
  var CFG = {
    avatarUrl: "https://cdn.shopify.com/s/files/1/0605/9501/1684/files/etusivun_asiantuntija_kuva_1_1.webp",
    monogram: "H",
    badge: "Google 4,6 ★ · 280+ arvostelua",
    title: "Tervetuloa 👋",
    text: "Saisiko olla ilmainen kartoitus? 📋",
    buttons: [
      { label:"Kysy Tekoäly-Mikolta", action:"chat", kind:"primary" },
      { label:"Viesti WhatsAppissa", action:"url", url:"https://wa.me/358447965732", kind:"whatsapp" }
    ],
    showDelayMs: 2000,
    desktopOnly: false,
    oncePerVisit: true,
    GOOGLE_SCRIPT_URL: "https://script.google.com/macros/s/AKfycbxUgmBRWstsxEf5B4p0CjAYr64z6PXyNKkiOnOayo7ZR3Q37Ue0xZc_gjEMvvCY6sUpwQ/exec"
  };

  document.addEventListener("DOMContentLoaded", function(){
    if (window.Shopify && Shopify.designMode) return;
    if (CFG.desktopOnly && window.innerWidth <= 1024) return;
    if (CFG.oncePerVisit && sessionStorage.getItem("hesatekCardShown")) return;
    if (localStorage.getItem("hesatekCardClosed")) return;

    var sessionId = sessionStorage.getItem("lindy_session_id");
    if (!sessionId){ sessionId = Math.random().toString(36).substring(7); sessionStorage.setItem("lindy_session_id", sessionId); }
    var variant = sessionStorage.getItem("lindy_ab_variant");
    if (!variant){ variant = Math.random() < 0.5 ? "A" : "B"; sessionStorage.setItem("lindy_ab_variant", variant); }
    var activeRule = "DEFAULT";

    function trackEvent(eventName){
      if (!CFG.GOOGLE_SCRIPT_URL || CFG.GOOGLE_SCRIPT_URL.indexOf("http") === -1) return;
      try{
        fetch(CFG.GOOGLE_SCRIPT_URL,{
          method:"POST", mode:"no-cors",
          body:JSON.stringify({ variant:variant, event:eventName, sessionId:sessionId, url:window.location.href, rule:activeRule }),
          headers:{ "Content-Type":"application/json" }
        });
      }catch(e){}
    }

    function findLindyButton(){
      return document.querySelector('button[data-testid="lindy-messenger.button"]')
          || document.querySelector('[data-testid="lindy-messenger.button"]')
          || document.querySelector('#lindy-chat-button');
    }
    function openLindy(){
      var btn = findLindyButton();
      if (btn) btn.click();
    }
    function hideCard(){
      var c = document.getElementById("hesatek-lindy-card");
      if (c){ c.classList.remove("visible"); setTimeout(function(){ if(c.parentNode) c.parentNode.removeChild(c); }, 350); }
    }

    function buildCard(data){
      var title = (data && data.title) || CFG.title;
      var text = (data && data.text) || CFG.text;

      var card = document.createElement("div");
      card.id = "hesatek-lindy-card";

      var WA_ICON = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/></svg>';
      var btnHtml = CFG.buttons.map(function(b, i){
        var cls = "hes-btn";
        if (b.kind === "whatsapp") cls += " hes-btn--whatsapp";
        else if (b.kind === "ghost") cls += " hes-btn--ghost";
        var inner = (b.kind === "whatsapp" ? WA_ICON : "") + "<span>" + b.label + "</span>";
        return '<button type="button" class="'+cls+'" data-idx="'+i+'">'+inner+'</button>';
      }).join("");

      card.innerHTML =
        '<button type="button" class="hes-close" aria-label="Sulje">×</button>' +
        '<div class="hes-avatar">' +
          (CFG.avatarUrl
            ? '<img src="'+CFG.avatarUrl+'" alt="Hesatek" onerror="this.style.display=\'none\';this.parentNode.querySelector(\'.hes-mono\').style.display=\'block\';">'
            : '') +
          '<span class="hes-mono" style="display:'+(CFG.avatarUrl?'none':'block')+'">'+CFG.monogram+'</span>' +
        '</div>' +
        '<div class="hes-badge"><span class="dot"></span><span>'+CFG.badge+'</span></div>' +
        '<div class="hes-title">'+title+'</div>' +
        '<p class="hes-text">'+text+'</p>' +
        btnHtml;

      document.body.appendChild(card);

      setTimeout(function(){ card.classList.add("visible"); trackEvent("IMPRESSION"); }, 50);

      card.querySelector(".hes-close").addEventListener("click", function(e){
        e.stopPropagation();
        trackEvent("DISMISS");
        localStorage.setItem("hesatekCardClosed","true");
        hideCard();
      });

      card.querySelectorAll(".hes-btn").forEach(function(el){
        el.addEventListener("click", function(){
          var b = CFG.buttons[parseInt(el.getAttribute("data-idx"),10)];
          trackEvent("CLICK_" + (b.kind === "whatsapp" ? "WHATSAPP" : (b.action === "url" ? "BOOK" : "CHAT")));
          if (b.action === "url" && b.url){
            window.open(b.url, "_blank");
          } else {
            openLindy();
          }
          hideCard();
        });
      });

      var f = setInterval(function(){
        var lb = findLindyButton();
        if (lb){ lb.addEventListener("click", hideCard); clearInterval(f); }
      }, 1000);
      setTimeout(function(){ clearInterval(f); }, 15000);

      sessionStorage.setItem("hesatekCardShown","true");
    }

    function start(){
      if (CFG.GOOGLE_SCRIPT_URL && CFG.GOOGLE_SCRIPT_URL.indexOf("http") !== -1){
        var url = CFG.GOOGLE_SCRIPT_URL + "?url=" + encodeURIComponent(window.location.href);
        var ctrl = new AbortController();
        var t = setTimeout(function(){ ctrl.abort(); }, 3000);
        fetch(url, { signal:ctrl.signal })
          .then(function(r){ return r.json(); })
          .then(function(d){
            clearTimeout(t);
            if (d && d.rule) activeRule = d.rule;
            var v = d && d[variant];
            buildCard(v && v.text ? { text:v.text, title:v.title } : null);
          })
          .catch(function(){ clearTimeout(t); buildCard(null); });
      } else {
        buildCard(null);
      }
    }

    setTimeout(start, CFG.showDelayMs);
  });
})();
